/**
 * ReviewActionButtons - Action buttons for customer reviews section
 * Contains "Write a review" and "Read all reviews" buttons
 */

import type { FC } from "react";
import classNames from "classnames";
import { usePrismicLabels } from "~/hooks/usePrismicLabel";
import { getReviewUrl } from "../utils";

interface ReviewActionButtonsProps {
  locale: string; // e.g., "nl_NL", "de_DE"
  className?: string;
}

export const ReviewActionButtons: FC<ReviewActionButtonsProps> = ({locale}) => {
  const { $pt } = usePrismicLabels();
  const reviewUrl = getReviewUrl(locale);

  return (
    <div
      className={classNames(
        "d-flex flex-column flex-sm-row justify-content-end align-items-center gap-3 review_action_buttons_section mt-4"
      )}
    >
      {/* 3. Semantic Change: Use <a> for navigation, not <button>.
         "Read All Reviews" takes you somewhere, so it is a link.
      */}
      <a
        href={reviewUrl}
        target="_blank"        // Open external links in new tab
        rel="noopener noreferrer" // Security best practice for target="_blank"
        className="btn btn-primary px-4 py-2 rounded-3 text-black d-inline-flex align-items-center rounded-1 text-decoration-none"
      >
        <span>{$pt("reviews_read_all_reviews")}</span>
        
        {/* Icon */}
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="currentColor"
          className="ml-2"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M6 12L10 8L6 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none" />
        </svg>
      </a>
    </div>
  );
};

export default ReviewActionButtons;